import { render, staticRenderFns } from "./PaymentLinkExpired.vue?vue&type=template&id=0f272a8d&scoped=true"
import script from "./PaymentLinkExpired.vue?vue&type=script&lang=js"
export * from "./PaymentLinkExpired.vue?vue&type=script&lang=js"
import style0 from "./PaymentLinkExpired.vue?vue&type=style&index=0&id=0f272a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f272a8d",
  null
  
)

export default component.exports